module.exports = __webpack_public_path__ + "img/normal_multiplier_1.bc92f047.png";